import React, { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";

// * Import Custom Components
import JobRole from "./JobRole";
import FunctionsInfo from "./FunctionsInfo";
import WelcomeScreen from "./welcomeScreen";
import FinalScreen from "./FinalScreen";
import LocationScreen from "./LocationScreen";
import Loader from "../../components/Loader";
import StepperComponent from "../../components/Stepper/Stepper";
import Error from "../../components/Error/Error";
import Box from "../../kit/Box";

import { getSignupTemplate } from "../../services/api";

// * Import styles
import { accountSetupStyles } from "../../theme/style";

// # Component
const AccountSetup = () => {
  // # States
  const [activeScreen, setActiveScreen] = useState(1);
  const [activeStep, setActiveStep] = useState(0);
  const [dataLoading, setDataLoading] = useState(true);
  const [signupTemplateData, setSignupTemplateData] = useState({
    status: "loading",
    message: "",
    data: {},
  });
  const theme = useTheme();
  const classes = accountSetupStyles(theme);

  useEffect(() => {
    const fetchSignupTemplate = async () => {
      try {
        const response = await getSignupTemplate();
        setSignupTemplateData({
          status: "success",
          message: "",
          data: response.data.data.signup_template,
        });
      } catch (err) {
        setSignupTemplateData({
          status: "error",
          message: err?.error || "",
          data: {},
        });
        console.log("error", err);
      }
    };
    fetchSignupTemplate();
    // eslint-disable-next-line
  }, []);

  const steps = ["Location", "Function", "Job Role"];

  // # JSX
  return (
    <>
      <>{signupTemplateData.status === "loading" && <Loader />}</>
      <div className={classes.setupContainer}>
        <section className={classes.setupSection}>
          <>
            {[2, 3, 4].includes(activeScreen) && dataLoading && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  position: "absolute",
                  top: theme.size[30],
                  flexDirection: "column",
                  width: "30%",
                  marginTop: theme.size[50],
                  left: "calc(100% - 85%)",
                }}
              >
                <StepperComponent activeStep={activeStep} steps={steps} />
              </Box>
            )}
          </>
          <>
            {signupTemplateData.status === "success" && (
              <>
                {activeScreen === 1 ? (
                  <WelcomeScreen
                    templateData={signupTemplateData.data.welcome_screen}
                    setActiveScreen={setActiveScreen}
                  />
                ) : activeScreen === 2 && activeStep === 0 ? (
                  <LocationScreen
                    templateData={signupTemplateData.data.geographies}
                    setActiveScreen={setActiveScreen}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                  />
                ) : activeScreen === 3 && activeStep === 1 ? (
                  <FunctionsInfo
                    templateData={signupTemplateData.data.functions}
                    setActiveScreen={setActiveScreen}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                  />
                ) : activeScreen === 4 && activeStep === 2 ? (
                  <JobRole
                    templateData={signupTemplateData.data.job_roles}
                    setActiveScreen={setActiveScreen}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    setDataLoading={setDataLoading}
                  />
                ) : activeScreen === 5 ? (
                  <FinalScreen setActiveScreen={setActiveScreen} />
                ) : null}
              </>
            )}
          </>
        </section>
      </div>
      <>
        {signupTemplateData.status === "error" && (
          <Error
            message={"Something went wrong"}
            fontSize={theme.size[16]}
            margin={theme.margin[1]}
            imageHeight={"30vh"}
            errHeight={"100vh"}
            paddingTop={theme.size[200]}
          />
        )}
      </>
    </>
  );
};

// # Exports
export default AccountSetup;
